import { REGISTRATION_STEP_STATUS } from '../types';

export interface SignupStorageType {
  verificationCodeId: string;
  step: REGISTRATION_STEP_STATUS;
  phone: string;
  token: string;
  codeLength: number;
}

const signupStorage = {
  getSignupStorage(): SignupStorageType | undefined {
    const signupStorage = localStorage.getItem('signup');
    if (signupStorage) {
      const typedStorage = JSON.parse(signupStorage) as SignupStorageType;
      return typedStorage;
    }

    return undefined;
  },

  setKeyStorage(key: keyof SignupStorageType, value: any): void {
    const storage = this.getSignupStorage();
    let payload = { [key]: value };
    if (storage) {
      payload = { ...storage, ...payload };
    }
    localStorage.setItem('signup', JSON.stringify(payload));
  },

  clearStorage(): void {
    localStorage.setItem('signup', '');
  },
};

export default signupStorage;
